import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React from "react";
import { Link } from "react-router-dom";
import { COLORS } from "../../Constants/styles";

const isExternal = (href: string) => /^https?:\/\//.test(href) || href === '#';

const CustomTextButton = ({ label = "Learn More", color = '#000000', href = "#" }) => {
    const MotionLink = isExternal(href)
        ? motion.a
        : motion(Link as React.FC<{ to: string; style?: React.CSSProperties; className?: string }>);
    const linkProps = isExternal(href) ? { href } : { to: href };

    return (
        <MotionLink
            {...linkProps}
            style={{ textDecoration: "none", display: "inline-block" }}
            initial="initial"
            whileHover="hover"
        >
            <Box
                component={motion.div}
                variants={{
                    initial: {},
                    hover: { scale: 1.05 },
                }}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mt: 3,
                }}
            >
                {/* Circle with Arrow */}
                <motion.div
                    variants={{
                        initial: {
                            width: 32,
                            backgroundColor: COLORS.accentLime,
                            color: COLORS.accentDarkGreen,
                        },
                        hover: {
                            width: 48,
                            backgroundColor: COLORS.accentDarkGreen,
                            color: COLORS.accentLime,
                        },
                    }}
                    transition={{ duration: 0.4 }}
                    style={{
                        height: 32,
                        borderRadius: "50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                    }}
                >
                    <ArrowForwardIcon fontSize="small" />
                </motion.div>

                {/* Text - No color change */}
                <Typography
                    variant="button"
                    sx={{
                        color: color,
                        fontWeight: 600,
                        fontSize: "0.875rem",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        fontFamily: "'Big Shoulders Text', sans-serif",
                        
                    }}
                >
                    {label}
                </Typography>
            </Box>
        </MotionLink>
    );
};

export default CustomTextButton;
